class App {

	constructor (appAutoload, frameworkAutoload, appRoutes, frameworkRoutes) {

		window.app = this;

		this.ajaxPath = this.getAjaxPath() ?? null;
		this.cookieDomain = document.head.querySelector('meta[name=cookie-domain]')?.getAttribute('content') ?? null;
		this.environment = document.head.querySelector('meta[name=environment]')?.getAttribute('content') ?? null;
		this.framework = document.head.querySelector('meta[name=framework]')?.getAttribute('content') ?? null;
		this.language = this.getLanguage();
		this.route = document.head.querySelector('meta[name=route]')?.getAttribute('content') ?? null;
		this.routePath = document.head.querySelector('meta[name=route-path]')?.getAttribute('content') ?? null;
		this.currentRouteName = this.formatCurrentRouteName(this.route);
		this.url = this.getUrl();
		this.passwordStrengtUrl = '/logins/passwordstrength';
		this.version = document.head.querySelector('meta[name=version]')?.getAttribute('content') ?? null;
		this.appAutoload = appAutoload;
		this.frameworkAutoload = frameworkAutoload;
		this.routeScripts = { ...appRoutes, ...frameworkRoutes };
	}

	init(Router) {
		this.router = new Router(this.route, this.routePath, this.appAutoload, this.frameworkAutoload, this.routeScripts, this.currentRouteName);

		this.domStateReady(() => {
			if (this.environment == 'dev' || this.environment == 'stage') {
				console.log(this);
			}
		});
	}

	getAjaxPath() {
		let ajaxPath = document.head.querySelector('meta[name=path]')?.getAttribute('content');
		if (typeof ajaxPath !== 'undefined' && ajaxPath !== '' && ajaxPath?.charAt(ajaxPath.length - 1) != '/') {
			ajaxPath = ajaxPath + '/';
		}
		return ajaxPath ?? null;
	}

	getLanguage(language = 'nl_NL') {
		let metaAppLang = document.head.querySelector('meta[name=app-language]')?.getAttribute('content');
		if (typeof metaAppLang !== 'undefined' && metaAppLang !== '' && (/^[a-z]{2}_[A-Z]{2}$/i.test(metaAppLang))) {
			if (metaAppLang.substring(0, 2) == 'nl') {
				language = 'nl_NL';
			} else if (metaAppLang.substring(0, 2) == 'en') {
				language = 'en_US';
			}
		}
		return language;
	}

	getUrl() {
		let url = window.location.href;
		if (typeof url !== 'undefined' && url !== '') {
			if (url.charAt(url.length - 1) == '#') {
				url = url.substr(0, url.length - 1);
			}
			if (url.charAt(url.length - 1) != '/') {
				url = url + '/';
			}
		}
		return url || null;
	}

	formatCurrentRouteName(currentRoute) {
		return currentRoute?.toLowerCase().replace(/\/(.)/g, (_, c) => c.toUpperCase());
	}

	domStateReady(callbackFunction) {
		if (document.readyState !== 'loading') {
			setTimeout(callbackFunction, 1);
		} else {
			document.addEventListener('DOMContentLoaded', () => {
				setTimeout(callbackFunction, 1);
			});
		}
	}

	log(message) {
		if (this.environment == 'dev' || this.environment == 'stage') {
			console.log(message);
		}
	}

}

export default App;
